import script from "./token-list.vue?vue&type=script&setup=true&lang=js"
export * from "./token-list.vue?vue&type=script&setup=true&lang=js"

import "./token-list.vue?vue&type=style&index=0&id=5fa5a73d&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa5a73d"]])

export default __exports__